import { useAction } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useEffectOnce } from 'react-use'
import styled, { css } from 'styled-components'

import {
  commentsScrollEvent,
  commentsUpdatedTotalEvent,
} from '@root/features/comment/atoms'
import { CommentIcon, mediaMaxDesktopSmall } from '@root/shared/ui-kit'

export const TradeTablesActionsComment = () => {
  const { t } = useTranslation()
  const [commentsCount, setCommentsCount] = useState(0)

  useEffectOnce(() =>
    commentsUpdatedTotalEvent.onCall((_, __, [totalCount]) =>
      setCommentsCount(totalCount),
    ),
  )

  const scrollToComments = useAction(commentsScrollEvent)
  const handleScrollToComments = () => scrollToComments()

  return (
    <Root>
      <CommentsButton type="button" onClick={handleScrollToComments}>
        <CommentIcon size={14} />
        <Text>{t('comment.comments', { count: commentsCount })}</Text>
      </CommentsButton>
    </Root>
  )
}

const Root = styled.div``

const CommentsButton = styled.button`
  color: var(--text-10);
  border: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;

  padding-inline: 18px;

  background: transparent;
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  cursor: pointer;

  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  height: 38px;

  transition: all 100ms ease-in;

  &:hover {
    color: var(--text-12);
    border-bottom: 2px solid var(--primary-9);
  }

  ${mediaMaxDesktopSmall(css`
    padding-inline: 8px;
    font-size: 11px;
    font-weight: 700;
    height: 28px;
  `)}
`
const Text = styled.span`
  ${mediaMaxDesktopSmall(css`
    display: none;
  `)}
`
